import { render, staticRenderFns } from "./detailComment.vue?vue&type=template&id=971d6da0&scoped=true&"
import script from "./detailComment.vue?vue&type=script&lang=js&"
export * from "./detailComment.vue?vue&type=script&lang=js&"
import style0 from "./detailComment.vue?vue&type=style&index=0&id=971d6da0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971d6da0",
  null
  
)

export default component.exports